import {BehaviorSubject} from 'rxjs';
import {toEnglishNumber} from 'components/utils/StringUtility';
import {callApi, callEmptyParamsApi} from "../connection/ClientApi";
import apiUrls from '../connection/Urls';
import Urls from '../connection/Urls';
import {basketViewModel} from "./Basket.viewModel";

const userSubject = new BehaviorSubject({
    token: localStorage.getItem('token') !== undefined ?
        localStorage.getItem('token') :
        '',
    customer_id: localStorage.getItem('customer_id') !== undefined ?
        localStorage.getItem('customer_id') :
        '',
    date_born: localStorage.getItem('date_born') !== undefined ?
        localStorage.getItem('date_born') :
        '',
    email: localStorage.getItem('email') !== undefined ?
        localStorage.getItem('email') :
        '',
    full_name: localStorage.getItem('full_name') !== undefined ?
        localStorage.getItem('full_name') :
        '',
    gender: localStorage.getItem('gender') !== undefined ?
        localStorage.getItem('gender') :
        '',
    meli_code: localStorage.getItem('meli_code') !== undefined ?
        localStorage.getItem('meli_code') :
        '',
    telephone: localStorage.getItem('telephone') !== undefined ?
        localStorage.getItem('telephone') :
        ''
})

export const authenticationViewModel = {
    login,
    changeNumber,
    verify,
    requestUser,
    requestEditUser,
    logout,
    user: userSubject.asObservable(),
    get isLogin() {
        let user = userSubject.value
        return !(user === null || user === undefined || user.token === null || user.token === "")
    },
    get userObject() {
        return userSubject.value
    }
}

function login(celphone, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("telephone", toEnglishNumber(celphone))
    callApi(apiUrls.login, params, () => {
        logout()
        onSuccess()
    }, onFailure, onStart, onEnd)
}

function changeNumber(celphone, onSuccess) {
    let params = new FormData()
    params.append("telephone", toEnglishNumber(celphone))
    callApi(apiUrls.editLoginNumber, params, () => {
        logout()
        onSuccess()
    }, () => {
        logout()
        onSuccess()
    })
}

function verify(telephone, invitedCode, code, onSuccess, onFailure, onStart, onEnd) {
    let params = new FormData()
    params.append("telephone", toEnglishNumber(telephone))
    params.append("code", toEnglishNumber(code))
    params.append("ref_code", toEnglishNumber(invitedCode))
    params.append("device_token", '')
    callApi(apiUrls.loginWithVerifyCode, params, (data) => {
        localStorage.setItem('token', data.token)
        requestUser(() => {
            basketViewModel.sendLocalDataToServer(() => {
                onSuccess(data)
            })
        })
    }, onFailure, onStart, onEnd)
}

function requestUser(onSuccess) {
    callEmptyParamsApi(Urls.getUser, (data) => {
        localStorage.setItem('customer_id', data.list.customer_id)
        localStorage.setItem('date_born', data.list.date_born)
        localStorage.setItem('email', data.list.email)
        localStorage.setItem('full_name', data.list.full_name)
        localStorage.setItem('gender', data.list.gender)
        localStorage.setItem('meli_code', data.list.meli_code)
        localStorage.setItem('telephone', data.list.telephone)
        userSubject.next(getLocalUser())
        if (onSuccess) {
            onSuccess()
        }
    })
}

function requestEditUser(
    fullName,
    email,
    nationalId,
    birthdate,
    gender,
    onSuccess,
    onFailure,
    onStart,
    onEnd
) {
    let params = new FormData()
    params.append("full_name", fullName)
    params.append("email", email)
    params.append("meli_code", nationalId)
    params.append("gender", gender)
    params.append('date_born', birthdate)
    callApi(Urls.editProfile, params, () => {

        localStorage.setItem('full_name', fullName)
        localStorage.setItem('email', email)
        localStorage.setItem('meli_code', nationalId)
        localStorage.setItem('date_born', birthdate)
        localStorage.setItem('gender', gender)

        userSubject.next(getLocalUser())

        onSuccess()
    }, onFailure, onStart, onEnd)
}

function getLocalUser() {
    return {
        customer_id: localStorage.getItem('customer_id'),
        date_born: localStorage.getItem('date_born'),
        email: localStorage.getItem('email'),
        full_name: localStorage.getItem('full_name'),
        gender: localStorage.getItem('gender'),
        meli_code: localStorage.getItem('meli_code'),
        token: localStorage.getItem('token'),
        telephone: localStorage.getItem('telephone')
    }
}

function logout() {
    localStorage.removeItem('customer_id')
    localStorage.removeItem('date_born')
    localStorage.removeItem('email')
    localStorage.removeItem('full_name')
    localStorage.removeItem('gender')
    localStorage.removeItem('meli_code')
    localStorage.removeItem('token')
    localStorage.removeItem('telephone')
    userSubject.next(null)
}